module.exports = __webpack_public_path__ + "img/ausgewaehlte_produkte.420f786.svg";